
// 终端列表
const deviceList = (resolve) => {
  import('components/viewCompany/deviceList').then((module) => {
    resolve(module)
  })
}
// 用户列表
const clientList = (resolve) => {
  import('components/viewCompany/clientList').then((module) => {
    resolve(module)
  })
}

const viewCompanyRouter = {
  viewCompanyPath: [
    {
      path: '/viewCompany/device',
      component: deviceList
    },
    {
      path: '/viewCompany/client',
      component: clientList
    }
  ]
}

export default viewCompanyRouter



// WEBPACK FOOTER //
// ./src/router/viewCompany.js